import { takeLatest, put, all, fork } from 'redux-saga/effects'

import * as actions from '../actions/actions'

export default function* errorSaga() {
  yield all([
    fork(watchFetchErrorRequestServer),
    fork(watchFetchErrorRequestClient)
  ]);
}

function* watchFetchErrorRequestServer() {
  yield takeLatest(
    actions.FETCH_ERROR_REQUEST_SERVER,
    fetchErrorRequestServer
  )
}

function* watchFetchErrorRequestClient() {
  yield takeLatest(
      actions.FETCH_ERROR_REQUEST_CLIENT,
      fetchErrorRequestClient
  )
}

function* fetchErrorRequestServer(error) {
  yield put({ type: actions.FETCH_ERROR_SERVER, error: error })
}

function* fetchErrorRequestClient(error) {
  yield put({ type: actions.FETCH_ERROR_CLIENT, error: error })
}